import { useContentfulLiveUpdates } from "@contentful/live-preview/react"

import FlexibleData from "../../lib/flexibleData"
import Layout from "../../layout"
import MarketoForm from "../../components/marketoForm"
import Block from "../../components/block"
import {
  contact_sales,
  form_container,
  row_container,
  content_container
} from "./styles.module.scss"

export async function getStaticProps(context) {
  const preview = process.env.NODE_ENV === "development" || context.draftMode || false
  const previewEnv = context?.previewData?.environment || null
  const data = (await FlexibleData.fetch("contact-sales", preview, previewEnv)) ?? []

  return {
    props: { preview, data }
  }
}

const ContactSales = ({ data, preview }) => {
  const liveData = useContentfulLiveUpdates(data)
  const blocks = liveData.modulesCollection.items

  return (
    <Layout
      className={contact_sales}
      pageTitle={liveData.title}
      excerpt={liveData.excerpt}
      preview={preview}
      featuredImage={liveData.featuredImage}
      navSettings={{
        hideNavLeft: false,
        hideNavRight: true,
        customCta: {
          label: liveData?.ctaLabel,
          url: liveData?.ctaUrl
        }
      }}
    >
      <div className={row_container}>
        <div className={form_container}>
          <h1>Contact Sales</h1>
          <MarketoForm
            contentKey="demo-request"
            formId="2295"
            redirectUrl="/thank-you/contact-sales/"
          />
        </div>
        <div className={content_container}>
          <div>
            {(blocks || []).map((block, idx) => (
              <Block key={idx} template={block?.__typename} {...block} />
            ))}
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default ContactSales
